import { ROUTE_SEO_DEPARTMENT } from '..'
import addressPageQuery from '../../domain/cms/address-pages.query.json'
import { CMS_ADDRESS_PAGES } from '../../domain/cms/cms.constants'
import AddressNotFoundError from '../../domain/error/AddressNotFoundError'
import PageNotFoundError from '../../domain/error/PageNotFoundError'
import PermanentRedirectError from '../../domain/error/PermanentRedirectError'
import { bboxArrayToBboxArrays } from '../../domain/map/conversion'
import { generateFullRoute } from '../../domain/router/routeUtils'
import { renderPage } from '../../domain/seo/department.page'
import { extractCodeLabel } from '../../domain/utils/location'
import { fetchBrowserCmsAddressPageContent, searchArea } from '../../store/address/address.actions'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { mapUpdated } from '../../store/map/mapSlice'
import { geocodeForwardCtx, searchServiceCtx } from '../../store/search/search.service.constants'
import { setSearchTerms } from '../../store/search/searchSlice'
import { searchDepartmentCities } from '../../store/seo/seo-address.actions'
import { fetchServerCmsAddressPageContent } from '../../store/seo/seo-cms.actions'
import { slugify } from '../../utils/string'
import { technicalErrorCatcher } from '../routeErrors.utils'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ params, store: { dispatch, getState }, avoidRefetchingPageData }) => {
  if (avoidRefetchingPageData) {
    return fetchBrowserCmsAddressPageContent()(dispatch, getState)
  }

  const { location } = params
  const { code, label } = extractCodeLabel(location)
  if (!code || !label) throw new PageNotFoundError()

  return searchArea(location, geocodeForwardCtx.filter.county)(dispatch, getState)
    .then(() => {
      const firstAddress = selectFirstAddress(getState())

      if (firstAddress.geocode_level !== searchServiceCtx.geocodeLevel.admin7 || !firstAddress.departmentCode) {
        throw new AddressNotFoundError()
      }

      if (firstAddress.departmentCode !== code || slugify(firstAddress.departmentLabel) !== label)
        throw new PermanentRedirectError(
          generateFullRoute(ROUTE_SEO_DEPARTMENT, {
            location: `${firstAddress.departmentCode}-${slugify(firstAddress.departmentLabel)}`
          })
        )

      return Promise.all([
        dispatch(setSearchTerms(location)),
        __SERVER__ && searchDepartmentCities()(dispatch, getState),
        __SERVER__ && fetchServerCmsAddressPageContent(CMS_ADDRESS_PAGES, addressPageQuery)(dispatch, getState),
        __BROWSER__ && fetchBrowserCmsAddressPageContent()(dispatch, getState),
        dispatch(mapUpdated({ bbox: bboxArrayToBboxArrays(firstAddress.bbox) }))
      ])
    })
    .catch(technicalErrorCatcher)
}

export default handleRouteLoading({ onRouteEnter, renderPage })
